import getOcTheme from '../../theme/services/getOcTheme';

const { palette, spacing, typography } = getOcTheme();

export default {
  '& figure': {
    display: 'block',
    width: 'auto',
    margin: `${spacing(2)} auto`,
    textAlign: 'center',

    '& figcaption': {
      ...typography.caption,
      color: palette.text.onMain,
      width: '70%',
      background: 'inherit',
      position: 'static',
      margin: `${spacing(1)} auto`,
      paddingTop: spacing(0.5),
      borderTop: `1px solid ${palette.layout.line.divider}`,
    },

    '& p': {
      margin: 0,
    },

    '& a': {
      width: '100%',
      display: 'block',
      background: palette.background.primary,
    },

    '& img': {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
  },
  '& img': {
    maxWidth: '100%',
  },
  '& .oc-imageLink': {
    cursor: 'zoom-in',
    '&--disabled': {
      cursor: 'default',
      pointerEvents: 'none',
    },
  },
};
